var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs6: "" } },
        [
          _c(
            "v-menu",
            {
              ref: "startMenu",
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "full-width": "",
                "nudge-right": 20,
                "max-width": "290px",
                "min-width": "290px",
              },
              model: {
                value: _vm.startMenu,
                callback: function ($$v) {
                  _vm.startMenu = $$v
                },
                expression: "startMenu",
              },
            },
            [
              _c("v-text-field", {
                attrs: {
                  slot: "activator",
                  label: "Start Date",
                  error:
                    (!_vm.startDateParsed.isValid &&
                      _vm.startDateText.length > 0) ||
                    (!_vm.checkErrorStartDatePrecedesEndDate &&
                      _vm.startDateParsed.isValid &&
                      _vm.endDateParsed.isValid),
                  "prepend-icon": "event",
                },
                slot: "activator",
                model: {
                  value: _vm.prettyStartDate,
                  callback: function ($$v) {
                    _vm.prettyStartDate = $$v
                  },
                  expression: "prettyStartDate",
                },
              }),
              _vm._v(" "),
              _c(
                "v-date-picker",
                {
                  ref: "startDate",
                  attrs: {
                    value: _vm.startDate,
                    "no-title": "",
                    scrollable: "",
                    actions: "",
                    min: _vm.minDateBound,
                    max: _vm.maxDateBound,
                    events: _vm.setDateMark,
                  },
                  on: { input: _vm.onStartDateSelected },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "block", width: "100%" } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                this.$refs.startDate &&
                                this.$refs.startDate._data.activePicker ==
                                  "DATE",
                              expression:
                                "\n\t\t\t\t\t\t\t\tthis.$refs.startDate &&\n\t\t\t\t\t\t\t\t\tthis.$refs.startDate._data.activePicker ==\n\t\t\t\t\t\t\t\t\t\t'DATE'\n\t\t\t\t\t\t\t",
                            },
                          ],
                        },
                        [
                          _c("div", { staticStyle: { display: "block" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "padding-left": "8px",
                                },
                              },
                              [
                                _c("div", { staticClass: "showData" }),
                                _vm._v(" - Available data\n                "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "padding-left": "8px",
                                },
                              },
                              [
                                _c("div", { staticClass: "hideData" }),
                                _vm._v(" - Hidden data\n                "),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.startMenu = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.startMenu.save(
                                    _vm.startDateText
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Button.OK")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs6: "" } },
        [
          _c(
            "v-menu",
            {
              ref: "endMenu",
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "full-width": "",
                "nudge-right": 20,
                "max-width": "290px",
                "min-width": "290px",
              },
              model: {
                value: _vm.endMenu,
                callback: function ($$v) {
                  _vm.endMenu = $$v
                },
                expression: "endMenu",
              },
            },
            [
              _c("v-text-field", {
                attrs: {
                  slot: "activator",
                  label: "End Date",
                  error:
                    (!_vm.endDateParsed.isValid &&
                      _vm.endDateText.length > 0) ||
                    (!_vm.checkErrorStartDatePrecedesEndDate &&
                      _vm.endDateParsed.isValid &&
                      _vm.startDateParsed.isValid),
                  "prepend-icon": "event",
                },
                slot: "activator",
                model: {
                  value: _vm.prettyEndDate,
                  callback: function ($$v) {
                    _vm.prettyEndDate = $$v
                  },
                  expression: "prettyEndDate",
                },
              }),
              _vm._v(" "),
              _c(
                "v-date-picker",
                {
                  ref: "endDate",
                  attrs: {
                    value: _vm.endDate,
                    "no-title": "",
                    scrollable: "",
                    actions: "",
                    min: _vm.minDateBound,
                    max: _vm.maxDateBound,
                    events: _vm.setDateMark,
                  },
                  on: { input: _vm.onEndDateSelected },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "block", width: "100%" } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                this.$refs.endDate &&
                                this.$refs.endDate._data.activePicker == "DATE",
                              expression:
                                "\n\t\t\t\t\t\t\t\tthis.$refs.endDate &&\n\t\t\t\t\t\t\t\t\tthis.$refs.endDate._data.activePicker ==\n\t\t\t\t\t\t\t\t\t\t'DATE'\n\t\t\t\t\t\t\t",
                            },
                          ],
                          staticStyle: { display: "block", width: "100%" },
                        },
                        [
                          _c("div", { staticStyle: { display: "block" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "padding-left": "8px",
                                },
                              },
                              [
                                _c("div", { staticClass: "showData" }),
                                _vm._v(" - Available data\n                "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "padding-left": "8px",
                                },
                              },
                              [
                                _c("div", { staticClass: "hideData" }),
                                _vm._v(" - Hidden data\n                "),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.endMenu = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.endMenu.save(_vm.endDateText)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Button.OK")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs12: "" } }, [
        _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _vm.minDateBound != "" && _vm.maxDateBound != ""
              ? _c("span", [
                  _c("small", [
                    _vm._v(
                      "\n            Available data:\n            " +
                        _vm._s(
                          _vm.formatDateTime(_vm.minDateBound, {
                            format: "LL",
                            excludeUtcText: true,
                          })
                        ) +
                        " to " +
                        _vm._s(
                          _vm.formatDateTime(_vm.maxDateBound, {
                            format: "LL",
                            excludeUtcText: true,
                          })
                        ) +
                        "\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("preset-buttons", {
              attrs: {
                direction: _vm.direction,
                "min-date-bound": _vm.minDateBound,
                "max-date-bound": _vm.maxDateBound,
                "date-range-shortcuts": _vm.dateRangeShortcuts,
              },
              on: { input: _vm.onDatePresetSelected },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }